import {
  GetMetaSiteUrlsResponse,
  UrlType,
} from '@wix/ambassador-gg-store-setup-v1-store-setup-service/types';

export function hasPremiumDomainConnected(siteUrls: GetMetaSiteUrlsResponse | undefined): boolean {
  return siteUrls?.metaSiteUrls?.primary?.urlType === UrlType.DOMAIN;
}
